var path = 'modules/dcb-eaccount.pages.eadashboard/components/eaMessageDashboard/eaMessageDashboardList.tpl.html';
var html = "<dcui-table\n        loading=\"$ctrl.loading\"\n        fields=\"$ctrl.fields\"\n        on-get-data=\"$ctrl.getData(qo)\"\n        on-filter-changed=\"$ctrl.filterChanged(filter)\"\n        is-collapse-able=\"false\"\n        activate-paging=\"false\"\n        search-able=\"false\"\n        aggregation=\"false\"\n>\n</dcui-table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./~/ngtemplate-loader?relativeTo=/src/ui/modules/eaDashboard/components&prefix=modules/dcb-eaccount.pages.eadashboard/components!./~/raw-loader!./src/ui/modules/eaDashboard/components/eaMessageDashboard/eaMessageDashboardList.tpl.html
// module id = 892
// module chunks = 12